import type { ButtonHTMLAttributes } from 'react';

type Variante = 'primario' | 'secundario' | 'escanear' | 'destructivo';

const CLASES: Record<Variante, string> = {
  primario:
    'min-h-tactil rounded-brand bg-brand-primary px-4 font-medium text-brand-primary-fg disabled:opacity-50',
  secundario:
    'min-h-tactil rounded-brand border border-brand-border px-4 font-medium text-brand-text disabled:opacity-50',
  escanear:
    'min-h-tactil rounded-brand bg-brand-secondary px-4 font-semibold text-brand-secondary-fg disabled:opacity-50',
  destructivo: 'min-h-tactil rounded-brand bg-brand-danger px-4 font-medium text-brand-primary-fg disabled:opacity-50',
};

export function Btn(
  props: ButtonHTMLAttributes<HTMLButtonElement> & { readonly variante?: Variante },
): React.JSX.Element {
  const { variante = 'primario', className, type, ...resto } = props;
  return <button type={type ?? 'button'} className={`${CLASES[variante]} ${className ?? ''}`} {...resto} />;
}
